import { string, oneOf, oneOfType, number, element } from 'prop-types';
import classnames from 'classnames';
import React from 'react';
import { Icon, Shelf } from '@chaser/components';
import style from './ChaserToken.module.scss';

const ChaserToken = ({ children, intent = 'warning', className = '' }) => (
  <Shelf
    gap="xxsmall"
    className={classnames(className, style.token, style[intent])}
    flexWrap="nowrap"
  >
    {intent === 'success' && <Icon name="tick" color="Green" size={12} />}
    {intent === 'danger' && <Icon name="alert-square" color="Red" size={12} />}
    <span>{children}</span>
  </Shelf>
);

ChaserToken.propTypes = {
  children: oneOfType([element, string]).isRequired,
  intent: oneOf(['warning', 'neutral', 'success', 'info', 'danger']),
  className: oneOfType([string, number]),
};

export default ChaserToken;
